import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Section, InnerSection } from '../../../styles/section/section';

export const SectionWrapper = styled(Section)`
  padding-top: 2rem;
`;

export const InnerSectionWrapper = styled(InnerSection)`
  padding-top: 0;
  padding-bottom: 1rem;
`;

export const ArticleName = styled.h3`
  color: ${(props) => props.theme.color.primary.v600};
  font-family: Brandon Text;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
  padding-bottom: 15px;
`;

export const random = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const ContentWrapper = styled.div`
  max-width: 796px;
`;

export const skeletonKeyframes = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonLine = styled.span`
  background-color: #eee;
  background-image: linear-gradient(90deg, #eee, #f5f5f5, #eee);
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  display: inline-block;
  line-height: 1;
  width: ${(props) => props.width || '100'}%;

  animation: ${skeletonKeyframes} 1.2s ease-in-out infinite;
`;

export const ArticleLoadingContent = () =>
  Array.from(Array(5).keys()).map((x) => (
    <SkeletonLine key={x} width={random(10, 100)}>
      &zwnj;
    </SkeletonLine>
  ));
